import { motion } from "framer-motion";

import { Attribute } from "../../../../gql/graphql";
import { CardContent } from "../../../shared/CardContent";
import { QUICKRANK_SELECTED_CARD_Y, QUICKRANK_SELECTED_CARD_DURATION } from "../../../../constants";
import { useQuickRankCardPosition } from "../../../../hooks/quickrank/useQuickRankCardPosition";

import styles from "../Card/Card.module.scss";

export interface RatedCardProps {
  card: {
    index: number;
    attribute: Attribute;
  };
}

export const RatedCard = (props: RatedCardProps) => {
  const { card } = props;
  const { rated } = useQuickRankCardPosition(card);

  if (!rated) return null;

  return (
    <motion.div
      className={styles.card}
      style={{
        scale: 0.3,
        opacity: 0,
        top: 0,
        zIndex: 10000,
        left: 0,
        x: rated.x,
        y: rated.y,
        width: rated.width,
        height: rated.height,
      }}
      animate={{
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.5,
        },
      }}
      exit={{
        y: QUICKRANK_SELECTED_CARD_Y,
        opacity: 0,
        transition: {
          duration: QUICKRANK_SELECTED_CARD_DURATION,
        },
      }}
    >
      <CardContent isReversed={false} attribute={card.attribute} contentClass={styles.content} isDisabled={true} />
    </motion.div>
  );
};
